import { env } from '@repo/env';
import { loggerFactory } from '@repo/logger';
import cookies from 'js-cookie';
import { GraphQLClient } from './GraphQLClient';
import type { ClientConfig } from './types';
import { getSupergraphUrl } from './utils';

/**
 * Creates a new GraphQL client with the given configuration.
 * @param config The configuration for the client.
 * @returns GraphQLClient instance.
 */
export function getGraphQLClient(config?: Partial<ClientConfig>) {
  const url = config?.url ?? getSupergraphUrl();
  const logger =
    config?.logger ??
    loggerFactory({
      component: 'graphql-client',
      path: 'packages/supergraph/graphql-client',
    });

  let csrfToken;
  if (typeof window !== 'undefined') {
    csrfToken = cookies.get('csrf_token');
  }

  const shouldFetchWPDevData =
    env.NEXT_PUBLIC_DEPLOYABLE_ENV !== 'prod' && config?.shouldUseWpDevData === true;

  const headers: Record<string, string> = {
    'X-Client-Platform': 'server',
    'X-Caller-Client-ID': 'banking-shopping-client',
    'GraphQL-Client-Name': 'banking-shopping-client',
    ...(csrfToken ? { 'X-Header-CSRF-Token': csrfToken } : {}),
    ...(shouldFetchWPDevData ? { 'X-WP-API-Environment': 'dev' } : {}),
    ...config?.headers,
  };

  if (!headers['content-type'] && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  return new GraphQLClient({
    url,
    headers,
    logger,
  });
}
